import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * FAQAccordion — smooth expand/collapse.
 * Props:
 *   faqs – array of { q, a }
 *   theme – theme object from SERVICE_THEMES
 */
export default function FAQAccordion({ faqs, theme }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="space-y-2.5">
      {faqs.map((faq, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div
            key={idx}
            className={`rounded-xl overflow-hidden transition-all duration-200 ${
              isOpen ? 'shadow-sm' : ''
            }`}
            style={{ backgroundColor: isOpen ? theme.lightBg : '#f8fafc' }}
          >
            <button
              onClick={() => toggle(idx)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50/80 transition-colors"
            >
              <span className="text-sm font-semibold text-gray-800 pr-4">{faq.q}</span>
              <ChevronDown
                className={`w-4 h-4 text-gray-400 shrink-0 transition-transform duration-200 ${
                  isOpen ? 'rotate-180' : ''
                }`}
              />
            </button>
            <div
              className="transition-all duration-300 ease-in-out overflow-hidden"
              style={{
                maxHeight: isOpen ? '200px' : '0px',
                opacity: isOpen ? 1 : 0,
              }}
            >
              <div className="px-4 pb-4 pt-0">
                <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
